"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.radioMotionTheme = exports.radioLabelTheme = exports.radioInnerDotTheme = exports.radioIconTheme = exports.radioFocusTheme = exports.radioBorderTheme = void 0;
var _designTokens = require("@smartsheet/design-tokens");
var _designTokensReact = require("@smartsheet/design-tokens-react");
var _sdsThemeInternal = require("@smartsheet/sds-theme-internal");
const radioBorderTheme = (0, _sdsThemeInternal.themed)({
  disabled: {
    checked: (0, _designTokensReact.color)("color--border--primary--weak"),
    unchecked: {
      "lodestar-light": (0, _designTokensReact.color)("color--border--neutral--weak"),
      "ursa-light": (0, _designTokensReact.color)("color--border--primary--weak")
    }
  },
  invalid: {
    rest: (0, _designTokensReact.color)("color--border--error--default"),
    hover: (0, _designTokensReact.color)("color--border--error--default"),
    active: (0, _designTokensReact.color)("color--border--error--default")
  },
  active: {
    unchecked: {
      "lodestar-light": (0, _designTokensReact.color)("color--border--spectrum-blue--default"),
      "ursa-light": (0, _designTokensReact.color)("color--border--neutral--default")
    },
    checked: {
      "lodestar-light": (0, _designTokensReact.color)("color--border--spectrum-blue--default"),
      "ursa-light": (0, _designTokensReact.color)("color--background--primary--stronger")
    }
  },
  rest: {
    unchecked: {
      "lodestar-light": (0, _designTokensReact.color)("color--border--neutral--strong"),
      "ursa-light": (0, _designTokensReact.color)("color--border--neutral--default")
    },
    checked: {
      "lodestar-light": _designTokens.lodestarColors.buttonPrimary,
      // no semantic token
      "ursa-light": (0, _designTokensReact.color)("color--border--primary--default")
    }
  },
  hover: {
    unchecked: {
      "lodestar-light": (0, _designTokensReact.color)("color--border--neutral--strong"),
      "ursa-light": (0, _designTokensReact.color)("color--border--neutral--default")
    },
    checked: {
      "lodestar-light": _designTokens.lodestarColors.buttonPrimary,
      // no semantic token
      "ursa-light": (0, _designTokensReact.color)("color--border--primary--default")
    }
  }
});
exports.radioBorderTheme = radioBorderTheme;
const radioInnerDotTheme = (0, _sdsThemeInternal.themed)({
  opacity: {
    checked: {
      "lodestar-light": 0,
      "ursa-light": 1
    },
    unchecked: 0
  }
});
exports.radioInnerDotTheme = radioInnerDotTheme;
const radioFocusTheme = (0, _sdsThemeInternal.themed)({
  gap: {
    "lodestar-light": 2,
    "ursa-light": 1
  }
});
exports.radioFocusTheme = radioFocusTheme;
const radioMotionTheme = (0, _sdsThemeInternal.themed)({
  default: {
    "lodestar-light": "box-shadow 0.2s",
    "ursa-light": `background-color ${_designTokens.motion.animation.default}`
  },
  animation: {
    "lodestar-light": "",
    "ursa-light": `${_designTokens.motion.animation.default}`
  }
});
exports.radioMotionTheme = radioMotionTheme;
const radioIconTheme = (0, _sdsThemeInternal.themed)({
  backgroundColor: {
    rest: (0, _designTokensReact.color)("color--background--surfaces--body"),
    hover: {
      "lodestar-light": (0, _designTokensReact.color)("color--background--surfaces--body"),
      "ursa-light": (0, _designTokensReact.color)("color--background--neutral--weaker")
    },
    active: {
      "lodestar-light": (0, _designTokensReact.color)("color--background--surfaces--body"),
      "ursa-light": (0, _designTokensReact.color)("color--background--neutral--default")
    },
    checked: {
      "lodestar-light": (0, _designTokensReact.color)("color--background--surfaces--body"),
      "ursa-light": (0, _designTokensReact.color)("color--background--surfaces--body")
    }
  },
  borderWidth: {
    rest: _designTokens.border.width20,
    hover: {
      "lodestar-light": "3px",
      "ursa-light": _designTokens.border.width20
    },
    checked: {
      large: {
        "lodestar-light": "6px",
        "ursa-light": _designTokens.border.width20
      },
      medium: {
        "lodestar-light": "4.5px",
        "ursa-light": _designTokens.border.width20
      }
    }
  },
  marginTop: {
    large: "0",
    medium: "1px"
  }
});
exports.radioIconTheme = radioIconTheme;
const radioLabelTheme = (0, _sdsThemeInternal.themed)({
  color: {
    disabled: {
      "lodestar-light": (0, _designTokensReact.color)("color--text--neutral--strong"),
      "ursa-light": (0, _designTokensReact.color)("color--text--neutral--default")
    },
    rest: "inherit"
  },
  gap: {
    "lodestar-light": "8px",
    "ursa-light": "6px"
  },
  marginTop: {
    large: "1px",
    medium: "0"
  },
  fontWeight: {
    checked: {
      "lodestar-light": _designTokens.typography.fontWeight.semiBold,
      "ursa-light": _designTokens.typography.fontWeight.medium
    },
    unchecked: _designTokens.typography.fontWeight.medium
  }
});
exports.radioLabelTheme = radioLabelTheme;
//# sourceMappingURL=radioTheme.js.map